/* eslint-disable no-console */
import { setLogger } from "react-query";

const noop = (): void => {};
export const silenceLogger = (): void => {
  setLogger({
    log: noop,
    warn: noop,
    error: noop,
  });
};

export const restoreLogger = (): void => {
  setLogger({
    log: (message) => {
      console.log(message);
    },
    warn: (message) => {
      console.warn(message);
    },
    error: (error) => {
      console.error(error);
    },
  });
};
